<template>
  <div>
    <h2>Qualifications</h2>
    <div class="box-content">
       <ul class="qualification-list">
         <li v-for="item in qualifications">
           <p class="qualification">{{ item }}</p>
         </li>
      </ul>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    computed: {
      ...mapGetters('About',{
        'qualifications': 'getQualification'
      })
    }
  }
</script>
<style scoped>
  ul{
    list-style: none;
    padding-left: 0;
  }
  .qualification-list > li{
    margin-bottom: 30px;
  }
  .qualification{
    font-weight: bold;
  }
</style>



// WEBPACK FOOTER //
// src/components/modules/QualificationList.vue